import { useEffect } from 'react';
import { makeHtmlId } from './id-utils';
const DEFAULT_CONFIG = {
    timeoutBeforeHighlight: 0,
    shouldScroll: true,
    shouldHighlightBackground: true,
    shouldUseTransitions: true,
    highlightDuration: 1500,
    smoothScroll: true,
};
const getConfig = ({ isMobile, type, screenshotMode, }) => ({
    CRUD_SUCCESS: Object.assign(Object.assign({}, DEFAULT_CONFIG), { shouldScroll: isMobile, shouldUseTransitions: !screenshotMode }),
    MARK_TARGET: Object.assign(Object.assign({}, DEFAULT_CONFIG), { shouldUseTransitions: !screenshotMode }),
    DEEP_LINK: Object.assign(Object.assign({}, DEFAULT_CONFIG), { highlightDuration: 5000, smoothScroll: false, shouldUseTransitions: !screenshotMode }),
    CRUD_ERROR: Object.assign(Object.assign({}, DEFAULT_CONFIG), { 
        // TODO: It's nice when error toast show first and only then we scrool to the element, but to
        // be fair there is some kind of unresolved bug when timeout is 0. Strange that it appears
        // only with 'error' highlights, and not 'success' ones - I do suspect Ricos editor, because it
        // breaks when the editor in highlighted element is just rendered.
        timeoutBeforeHighlight: 500, shouldHighlightBackground: false, shouldUseTransitions: !screenshotMode }),
    NAVIGATION_PROMPT: Object.assign(Object.assign({}, DEFAULT_CONFIG), { shouldHighlightBackground: false, shouldUseTransitions: !screenshotMode }),
}[type]);
export const HIGHLIGHT_CLASS = 'wc-highlight-bg-color';
const BG_TRANSITION_CLASS = 'wc-bg-transition';
const DISABLED_TRANSITION_CLASS = 'wc-disable-transition';
export const useHighlightComment = (highlight, isMobile, screenshotMode) => {
    useEffect(() => {
        if (highlight === null || highlight === void 0 ? void 0 : highlight.id) {
            const element = document.getElementById(makeHtmlId(highlight.id));
            const config = getConfig({
                isMobile,
                type: highlight.type,
                screenshotMode,
            });
            element && setTimeout(() => highlightElement(element, config), config.timeoutBeforeHighlight);
        }
    }, [highlight === null || highlight === void 0 ? void 0 : highlight.id, highlight === null || highlight === void 0 ? void 0 : highlight.timestamp, highlight === null || highlight === void 0 ? void 0 : highlight.type, isMobile]);
};
export const highlightNavigationPromptTarget = (htmlId, isMobile) => {
    const element = document.getElementById(htmlId);
    if (element) {
        highlightElement(element, getConfig({ isMobile, type: 'NAVIGATION_PROMPT' }));
    }
};
const highlightElement = (element, highlightConfig) => {
    if (highlightConfig.shouldScroll) {
        // Scrolling is skiped for deskotp 'CRUD_SUCCESS' highlights
        const commentRect = element.getBoundingClientRect();
        if (isOffscreen(commentRect)) {
            window.scrollBy({
                top: commentRect.top - document.documentElement.clientHeight / 4,
                left: 0,
                behavior: highlightConfig.smoothScroll ? 'smooth' : 'auto',
            });
        }
    }
    element.focus();
    if (highlightConfig.shouldHighlightBackground &&
        !element.classList.contains(HIGHLIGHT_CLASS) &&
        !element.classList.contains(BG_TRANSITION_CLASS)) {
        const transitionClass = highlightConfig.shouldUseTransitions
            ? BG_TRANSITION_CLASS
            : DISABLED_TRANSITION_CLASS;
        element.classList.add(HIGHLIGHT_CLASS, transitionClass);
        setTimeout(() => {
            element.classList.remove(HIGHLIGHT_CLASS);
            if (highlightConfig.shouldUseTransitions) {
            }
            setTimeout(() => element.classList.remove(transitionClass), 500);
        }, highlightConfig.highlightDuration);
    }
};
export const isOffscreen = (elementsRect) => {
    // Account for the permium banner
    const offset = document.documentElement.clientHeight / 12;
    const tooHigh = elementsRect.top - offset < 0;
    const tooLow = elementsRect.top + elementsRect.height > document.documentElement.clientHeight;
    return tooHigh || tooLow;
};
//# sourceMappingURL=use-highlight-comment.js.map